import {
  IconBuildingBank,
  IconCash,
  IconCreditCard,
  IconDeviceMobile,
  IconGift,
  IconReceipt,
  IconTicket,
  IconWallet,
} from '@tabler/icons-react';
import type { ReactNode } from 'react';

// Maps the well-known payment codes to Tabler icons. Unknown codes get a
// generic receipt icon — codes are tenant-defined so we can't be exhaustive.
const ICON_BY_CODE: Record<string, ReactNode> = {
  CASH: <IconCash size={18} stroke={1.6} />,
  VISA: <IconCreditCard size={18} stroke={1.6} />,
  MASTERCARD: <IconCreditCard size={18} stroke={1.6} />,
  MADA: <IconCreditCard size={18} stroke={1.6} />,
  APPLE_PAY: <IconDeviceMobile size={18} stroke={1.6} />,
  GOOGLE_PAY: <IconDeviceMobile size={18} stroke={1.6} />,
  BANK_TRANSFER: <IconBuildingBank size={18} stroke={1.6} />,
  WALLET: <IconWallet size={18} stroke={1.6} />,
  GIFT_CARD: <IconGift size={18} stroke={1.6} />,
  VOUCHER: <IconTicket size={18} stroke={1.6} />,
};

export function PaymentMethodIcon({ code }: { code: string }) {
  return ICON_BY_CODE[code.toUpperCase()] ?? <IconReceipt size={18} stroke={1.6} />;
}
